let accessToken = null;
let isAuthReady = false;
let authReadyResolve = null;
const authReadyPromise = new Promise((resolve) => {
  authReadyResolve = resolve;
});

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
  accessToken = token || null;
};

export const clearAccessToken = () => {
  accessToken = null;
};

export const markAuthReady = () => {
  isAuthReady = true;
  if (authReadyResolve) {
    authReadyResolve();
    authReadyResolve = null;
  }
};

export const waitForAuthReady = async () => {
  if (isAuthReady) return;
  if (!localStorage.getItem("user_data")) {
    markAuthReady();
    return;
  }
  await authReadyPromise;
};
